import LanguajeLocalStorage from '@/data/localStorage/LanguajeLocalStorage';
import StoreRepository from '@/data/repositories/StoreRepository';
import { IFooterLayoutProps } from '@/domain/interfaces/IFooterSections';
import { IAppointmentStore, IStore } from '@/domain/interfaces/IStore';

/** Representa el controlador que maneja los eventos de los casos de uso de la ienda
  * @returns {object} Funciones del controlador
*/
const StoreController = () => {

  /** Solicita la información de la tienda
    * @returns {IStore}
  */
  const getStoreData = async (storeId:number = 1): Promise<IStore> => {

    /** Instancia del Repository
    * @const {StoreRepository}
    */
    const storeRepository = StoreRepository.instance;
    const result = await storeRepository.getStoreData(storeId);

    return result.data;
  }

  /** Solicita la información de secciones del footer para la tienda
    * @returns {IFooterLayoutProps[]}
  */
  const getFooterSections = async (): Promise<IFooterLayoutProps[]> => {

    /** Instancia del Repository
    * @const {StoreRepository}
    */
    const storeRepository = StoreRepository.instance;
    const result = await storeRepository.getFooterSections();

    return result.data;
  }

  /** 
   * Envía solicitud de cita
   * 
  */
  const sendAppointment = async (appointmentForm: IAppointmentStore): Promise<boolean> => {

    /** Instancia del Repository
    * @const {StoreRepository}
    */
    const storeRepository = StoreRepository.instance;
    
    try {
      await storeRepository.sendAppointment(appointmentForm);  
      return true;
    } catch (error) {
      return false;
    }
    
  }

  /** Instancia del Repository Local Storage
   * @const {LanguajeLocalStorage}
   */
  const languajeRepository = new LanguajeLocalStorage;
  /** Obtiene el lenguaje almacenado en el localStorage */
  const getLanguaje = () => { return languajeRepository.getLanguage() };

  /** Actualiza el lenguaje y diccionario almacenados en localStorage */
  const setLanguage = (lang: string) => {
    languajeRepository.setLanguage(lang);
  }
  

  /**
   * retorna la funciones del controlador
   */
  return {  getStoreData,
            getFooterSections,
            sendAppointment,
            getLanguaje,
            setLanguage,
          };
};

export default StoreController;
